import { Controller } from "@hotwired/stimulus"

// Keeps the header and Safari's overscroll surface dark until the stage ends.
export default class extends Controller {
  static values = { stage: String, theme: { type: String, default: "dark" } }

  connect() {
    this.stage = document.getElementById(this.stageValue)
    this.stageBackground = getComputedStyle(this.stage).backgroundColor
    this.themeColor = document.querySelector('meta[name="theme-color"]')
    this.observeStage()
  }

  observeStage() {
    this.observer?.disconnect()
    const headerHeight = this.element.offsetHeight
    this.toggle(this.stage.getBoundingClientRect().bottom > headerHeight)
    this.observer = new IntersectionObserver(([entry]) => {
      // A stage pulled below the header is still the top of the page.
      // Only its bottom edge passing above the header ends the dark treatment.
      this.toggle(entry.boundingClientRect.bottom > headerHeight)
    }, {
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0
    })
    this.observer.observe(this.stage)
  }

  disconnect() {
    this.observer.disconnect()
    this.reset()
  }

  reset() {
    this.toggle(false)
  }

  toggle(onStage) {
    if (onStage) {
      this.element.dataset.theme = this.themeValue
      document.documentElement.style.setProperty("--teams-stage-background", this.stageBackground)
      this.themeColor.content = this.stageBackground
    } else {
      delete this.element.dataset.theme
      document.documentElement.style.removeProperty("--teams-stage-background")
      // The selected theme may have changed since connection or the last stage visit.
      this.themeColor.content = getComputedStyle(document.documentElement).getPropertyValue("--color-base-100").trim()
    }
  }
}
